import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import React from 'react';
import '../apps/SignIn.css';

export default function Copyright() {
  return (
    <Typography className="public-footer" component="div" variant="body2" color="textSecondary" align="center">
      {'© '}
      {new Date().getFullYear()}{' '}
      <Link color="inherit" href="https://ezcloudllc.com/">
        E-Z Cloud.
      </Link>{' '}
      All rights reserved.
      <br />
      <Link color="inherit" href="https://ezcloudllc.com/terms-of-service" target="_blank">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link color="inherit" href="https://responder.services.ezcloudllc.com/privacy-policy/" target="_blank">
        Privacy Policy
      </Link>
    </Typography>

  );
}
